import { makeContext, useContext, useNoContext } from '@use-gpu/live';

export type ViewFrameContextProps = number;

export const ViewFrameContext = makeContext<ViewFrameContextProps>(0, 'FrameContext');

export const usePerViewFrame   = () => useContext(ViewFrameContext);
export const useNoPerViewFrame = () => useNoContext(ViewFrameContext);
